import type {
  FrameArtworkProfile,
  FrameProfile,
} from '../types/doorConfiguration';

export type FrameJointConstruction = 'mitred' | 'butt';

export interface FrameProfileRenderSpec {
  artworkProfile: FrameArtworkProfile;
  joint: FrameJointConstruction;
}

/**
 * Product-facing profile choices resolve to artwork plus joint construction.
 * Butt Joint uses the timberbutt asset as authored, including its corner joints.
 */
export function resolveFrameProfileRenderSpec(
  profile: FrameProfile
): FrameProfileRenderSpec {
  if (profile === 'butt-joint') {
    return { artworkProfile: 'timberbutt', joint: 'mitred' };
  }
  return { artworkProfile: profile, joint: 'mitred' };
}
